var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"point"},[_c('recharge',{attrs:{"type":"2","exclusive":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }